// VAE (Novaeon's AI assistant) client configuration.
//
// These values come from the SEPARATE Firebase project that hosts the vaeChat
// Cloud Function (see /vae-backend). The Firebase web `apiKey` is NOT a secret —
// it only identifies the project and is safe to ship in the bundle. The real
// secret (the Anthropic key) lives server-side in the function.
//
// Supply them via env vars at build time (.env.local, or your host's env). Until
// they're present, VAE renders in a friendly "not configured yet" state instead
// of erroring — so the UI works in development before the backend exists.

const env = process.env;

export const FIREBASE_CONFIG = {
  apiKey: env.REACT_APP_VAE_API_KEY ?? "",
  authDomain: env.REACT_APP_VAE_AUTH_DOMAIN ?? "",
  projectId: env.REACT_APP_VAE_PROJECT_ID ?? "",
  appId: env.REACT_APP_VAE_APP_ID ?? "",
};

export const RECAPTCHA_SITE_KEY = env.REACT_APP_VAE_RECAPTCHA_SITE_KEY ?? "";

// Region the function is deployed to (matches setGlobalOptions in the backend).
export const FUNCTIONS_REGION = "us-central1";

// VAE is "live" only when the essentials are configured.
export const VAE_CONFIGURED = Boolean(
  FIREBASE_CONFIG.projectId && FIREBASE_CONFIG.apiKey && FIREBASE_CONFIG.appId && RECAPTCHA_SITE_KEY,
);
